/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Clubs_Group_TotalInputs */

const en_us2_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Group total: ${i?.total}`)
};

const pt_br2_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total do grupo: ${i?.total}`)
};

const es_419_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total del grupo: ${i?.total}`)
};

const pt_pt2_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total do grupo: ${i?.total}`)
};

const fr_fr2_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total du groupe : ${i?.total}`)
};

const de_de2_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gruppe gesamt: ${i?.total}`)
};

const it_it2_clubs_group_total = /** @type {(inputs: Clubs_Group_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totale del gruppo: ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Group total: {total}" |
*
* @param {Clubs_Group_TotalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_group_total = /** @type {((inputs: Clubs_Group_TotalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Group_TotalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_group_total(inputs)
	if (locale === "es-419") return es_419_clubs_group_total(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_group_total(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_group_total(inputs)
	if (locale === "de-DE") return de_de2_clubs_group_total(inputs)
	if (locale === "it-IT") return it_it2_clubs_group_total(inputs)
	return en_us2_clubs_group_total(inputs)
});
export { clubs_group_total as "clubs.group_total" }